(function () {
  'use strict';

  function footer() {
    if (document.querySelector('.v7-site-footer')) return;

    var old = document.querySelector(
      'footer.footer,.shopify-section-group-footer-group footer'
    );

    if (!old) return;

    var f = document.createElement('footer');
    f.className = 'v7-site-footer';

    f.innerHTML =
      '<div class="shell v7-footer-grid">' +
        '<div>' +
          '<a class="v7-logo" href="/" style="color:white">' +
            'thepopgift' +
          '</a>' +
          '<p>' +
            'Useful gifts for pets and the people who care for them.' +
          '</p>' +

          // [MODIFIED 1]
          // 在当前 V7 Footer 的品牌区域中预留社交媒体图标容器。
          '<div ' +
            'class="v7-social-slot" ' +
            'role="group" ' +
            'aria-label="Social media" ' +
            'style="margin-top:16px">' +
          '</div>' +

        '</div>' +

        '<div>' +
          '<b>Help</b>' +
          '<ul>' +
            '<li>' +
              '<a href="/pages/contact">Contact</a>' +
            '</li>' +
            '<li>' +
              '<a href="/policies/shipping-policy">Shipping</a>' +
            '</li>' +
            '<li>' +
              '<a href="/policies/refund-policy">Returns</a>' +
            '</li>' +
          '</ul>' +
        '</div>' +

        '<div>' +
          '<b>Legal</b>' +
          '<ul>' +
            '<li>' +
              '<a href="/policies/privacy-policy">Privacy</a>' +
            '</li>' +
            '<li>' +
              '<a href="/policies/terms-of-service">Terms</a>' +
            '</li>' +
          '</ul>' +
        '</div>' +

        '<div>' +
          '<b>Company details</b>' +
          '<p>YOU ONLY TRADING LIMITED</p>' +
          '<p>Room 1318–19, Hollywood Commercial Center, 610 Nathan Road, Mong Kok, Kowloon, Hong Kong</p>' +
          '<p><a href="mailto:support@thepopgift.com">support@thepopgift.com</a></p>' +
          '<p>We aim to reply within 2 business days.</p>' +
        '</div>' +
      '</div>';

    // [MODIFIED 2]
    // 从 Shopify 原始 Footer 中读取 Theme Editor 已生成的社交图标。
    // 这样 Facebook URL 仍由 Shopify Social media settings 管理，
    // 不需要在 tpg-v7.js 中再次硬编码 Facebook 地址。
    var sourceSocial = old.querySelector('.footer__list-social');
    var socialSlot = f.querySelector('.v7-social-slot');

    if (sourceSocial && socialSlot) {
      var clonedSocial = sourceSocial.cloneNode(true);

        // [MODIFIED 3]
        // 控制克隆后的社交图标排列和间距。
        clonedSocial.style.display = 'flex';
        clonedSocial.style.flexWrap = 'wrap';
        clonedSocial.style.alignItems = 'center';
        clonedSocial.style.justifyContent = 'flex-start';
        clonedSocial.style.gap = '4px';
        clonedSocial.style.margin = '0';
        clonedSocial.style.padding = '0';
        clonedSocial.style.listStyle = 'none';

        // 覆盖 Shrine 主题原本约 14.3px 的图标链接 padding，
        // 避免两个图标在视觉上相距过远。
        clonedSocial
        .querySelectorAll('.list-social__link')
        .forEach(function (link) {
            link.style.padding = '8px';
        });
        socialSlot.appendChild(clonedSocial);
    } 
    else if (socialSlot) {
      // 如果 Theme Editor 没有开启社交图标，或者没有配置任何社交链接，
      // 则不保留空白容器。
      socialSlot.remove();
    }

    // 保留原来的行为：隐藏旧 Footer，显示新建的 V7 Footer。
    old.style.display = 'none';
    old.parentNode.insertBefore(f, old);
  }

  function drawerA11y() {
    document
      .querySelectorAll('header-drawer details')
      .forEach(function (d) {
        if (d.dataset.v7A11y) return;

        d.dataset.v7A11y = 'true';

        var s = d.querySelector('summary');

        var sync = function () {
          if (s) {
            s.setAttribute(
              'aria-expanded',
              d.open ? 'true' : 'false'
            );
          }
        };

        d.addEventListener('toggle', sync);
        sync();
      });

    if (!document.documentElement.dataset.v7DrawerEsc) {
      document.documentElement.dataset.v7DrawerEsc = 'true';

      document.addEventListener(
        'keydown',
        function (e) {
          if (e.key !== 'Escape') return;

          var d = document.querySelector(
            'header-drawer details[open]'
          );

          if (!d) return;

          var s = d.querySelector('summary');

          if (s) {
            s.click();
            d.removeAttribute('open');
            s.setAttribute('aria-expanded', 'false');
            s.focus();
          }
        },
        true
      );
    }
  }

  function run() {
    footer();
    drawerA11y();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var queued = false;

  new MutationObserver(function () {
    if (queued) return;

    queued = true;

    requestAnimationFrame(function () {
      queued = false;
      run();
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
